<template>
  <div class="chart-container">
    <Bar :data="chartData" :options="chartOptions" />
  </div>
</template>

<script setup>
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
} from "chart.js";

import { Bar } from "vue-chartjs";
import { computed } from "vue";
/* eslint-disable */
// Define props
const props = defineProps({
  members: {
    type: [Number, String],   // allow both in case parent passes string/number
    required: true
  },
  applications: {
    type: [Number, String],
    required: true
  },
  booking: {
    type: [Number, String],
    default: 0
  },
  tournament: {
    type: [Number, String],
    default: 0
  }
});

// Register Chart.js components (do this once)
ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
);

// Make chartData reactive to prop changes
const chartData = computed(() => ({
  labels: ["Members", "Applications", "Bookings", "Tournaments"],
  datasets: [
    {
      label: "Overview",
      data: [
        Number(props.members) || 0,
        Number(props.applications) || 0,
        Number(props.booking) || 0,
        Number(props.tournament) || 0
      ],
      borderWidth: 1,
      // Optional: add nice colors
      backgroundColor: [
        "#3b82f6",
        "#10b981",
        "#f59e0b",
        "#ef4444"
      ]
    }
  ]
}));

const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    y: {
      beginAtZero: true
    }
  }
};
</script>

<style scoped>
.chart-container {
  width: 100%;
  height: 300px;
}
</style>